import React, { useState} from 'react';
import {parse, differenceInYears} from 'date-fns';
import { LabelText } from '../../components/Language';
import Aux from '../../hoc/Auxiliary';
import CalendarFooter from '../../components/UI/CalendarFooter/CalendarFooter';
import config from '../../common/const/config';
import './index.css';

export default function AuditFooter(props) {
    const fromRevenueDate= props.fromRevenueDate && parse(props.fromRevenueDate, "dd/MM/yyyy", new Date());
    const untilRevenueDate= props.untilRevenueDate && parse(props.untilRevenueDate, "dd/MM/yyyy", new Date());
    const [fromDate, setFromDate] = useState(fromRevenueDate);
    const [untilDate, setUntilDate] = useState(untilRevenueDate);
    const [error, setError] = useState("");
    const [isInValidFromDate, setIsInValidFromDate] = useState(false);
    const [isInValidUntilDate, setIsInValidUntilDate] = useState(false);


    const fromDateChangeHandler = (date) => {        
        if (date)
        {
            if( untilDate < date)    
            {
                props.onFromDateChange(date, true, "From Date should not be greator than Until Date");
            } 
            else if(untilDate && differenceInYears(untilDate, date) > config.maxValidDateRangeInYearDiff) {
                props.setIsValidDateRange(false);
                setFromDate(date);
                props.onFromDateChange(date, false, "");
                setIsInValidFromDate(true);
                setIsInValidUntilDate(true);
                setError("daterange-exceed");
            }
            else
            {
                props.setIsValidDateRange(true);
                setFromDate(date);
                props.onFromDateChange(date, false, "");
                setIsInValidFromDate(false);
                setIsInValidUntilDate(false);
                setError(null);
            } 
        }      
    }
    
    const untilDateChangeHandler = (date) => {
        if(date) 
        {
           if (fromDate > date)    
            {
                props.onUntilDateChange(date,true, "Until Date should not be less than From Date");
            } else if(fromDate && differenceInYears(date, fromDate) > config.maxValidDateRangeInYearDiff) {
                props.setIsValidDateRange(false);
                setUntilDate(date);
                props.onUntilDateChange(date, false, "");
                setIsInValidFromDate(true);
                setIsInValidUntilDate(true);
                setError("daterange-exceed");
            } else
            {
                props.setIsValidDateRange(true);
                setUntilDate(date);
                props.onUntilDateChange(date, false, "");
                setIsInValidFromDate(false);
                setIsInValidUntilDate(false);
                setError(null);
            }  
        }           
    }
    
    return (         
        <Aux> 
            <div className="audit-overview-footer-main">  
                <CalendarFooter fromDate={fromDate} untilDate={untilDate}
                    fromMinDate={props.fromMinDate} 
                    fromMaxDate={props.fromMaxDate} 
                    untilMinDate={props.untilMinDate} 
                    untilMaxDate={props.untilMaxDate} 
                    fromDateChangeHandler={fromDateChangeHandler}
                    untilDateChangeHandler={untilDateChangeHandler}
                    isInValidFromDate={isInValidFromDate}
                    isInValidUntilDate={isInValidUntilDate}
                />
            </div>  
            { error && error.trim() !== "" ? 
            <div className="audit-error-container-footer">
                <div className = "error-icon"/>
                <div className="error-msg">
                    <LabelText tid={error} />
                </div>
            </div>
            : undefined}
        </Aux>       
    );
}


